module.exports = __webpack_public_path__ + "img/VR.190b2762.png";